import { createContext, useContext, useState } from "react";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => {
    const s = localStorage.getItem("lf_auth");
    return s ? JSON.parse(s) : null;
  });
  const login = (a) => {
    setAuth(a);
    localStorage.setItem("lf_auth", JSON.stringify(a));
  };
  const logout = () => {
    setAuth(null);
    localStorage.removeItem("lf_auth");
  };
  return (
    <AuthCtx.Provider value={{ auth, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
